import Button from '@jetbrains/ring-ui/components/button/button'
import classNames from 'classnames'
import plur from 'plur'
import * as React from 'react'

import SvgIcon from '../../../../../common/SvgIcon/SvgIcon'

import styles from './InstancesCounter.css'

function InstancesCounter({
  count,
  busyCount,
  className,
}: {
  count: number
  busyCount: number
  className?: string | null | undefined
}) {
  return count === 0 ? (
    <span className={classNames(className, styles.couter)}>{'no agents'}</span>
  ) : (
    <Button className={classNames(className, styles.couter)} text>
      {busyCount > 0 ? (
        <>
          <span className={styles.runningCount}>{`${busyCount} ${plur(
            'agent',
            busyCount,
          )} running ${plur('build', busyCount)}`}</span>
          {busyCount < count ? ', ' : null}
        </>
      ) : null}
      {busyCount < count ? `${count} ${plur('agent', count)} in total` : ''}
      <SvgIcon icon={'chevron-down'} />
    </Button>
  )
}

export default InstancesCounter
